// Copyright ©️ 2026 eVolve MEP, LLC

import React from 'react';

import { Flex, type FlexProps } from '@mantine/core';
import type { GridApi } from 'ag-grid-enterprise';

import { EvolveIcon, type EvolveIconName } from 'assets/icons/EvolveIcon';
import { isNotNil } from 'helpers/isNotNil';

type Props = {
  label: React.ReactNode;
  icon?: EvolveIconName;
  gridApi?: GridApi | null;
} & FlexProps;

export const NoRowsOverlay = ({ gridApi, label, icon, ...props }: Props) => (
  <Flex
    direction="column"
    align="center"
    justify="center"
    gap="xs"
    px="md"
    fz={isNotNil(icon) ? 'xl' : undefined}
    c="gray"
    {...props}
    style={{
      animation: 'fadeIn .2s',
      lineHeight: 1.5,
      width: '100%',
      // TODO: `.style` can now be a function, need to handle it
      // oxlint-disable-next-line typescript/no-misused-spread
      ...props.style,
    }}
  >
    {isNotNil(icon) && <EvolveIcon size="xl" icon={icon} />}
    <Flex direction="column" align="center" justify="center">
      {Object.keys(gridApi?.getFilterModel() ?? {}).length > 0
        ? 'No results found matching the current filters.'
        : label}
    </Flex>
  </Flex>
);
